<template>
<footer class="footer">
  <div class="footer-cta">
    Get app
  </div>
  <div class="footer-buttons">
    <a class="footer-button" href="https://play.google.com/store/apps/details?id=com.buntai.cashbackalert" target="_blank">
      <img src="../assets/img/gp.svg" alt="google play">
    </a>
    <a class="footer-button" href="https://chrome.google.com/webstore/detail/cashback-alert/jjplgdahehldgdmahmiknpoeecbeadll" target="_blank">
      <img src="../assets/img/cs.svg" alt="chrome store">
    </a>
  </div>
  <div class="footer-static">
    <a class="footer-static-link" href="https://cashbackalert.net/terms/">Terms</a>
    <a class="footer-static-link" href="https://cashbackalert.net/privacy/">Privacy</a>
  </div>
  <div class="footer-copyright">
    Copyright © 2021. Cashback Alerts. All rights reserved.
  </div>
</footer>
</template>

<script>

export default {
  name: 'Footer',
}
</script>
